module.exports = __webpack_public_path__ + "static/step1-7b8e6d7df0d31577615497f55a95e4e4.png";